import * as React from "react";
import { Button, styled } from "@mui/material";
import { PatientColorMap } from "../../../../layout/patientColorMap";
import { LocationQuestionsMetaData } from "./locationQuestionsIndex";
import { useTranslate } from "../../../../hooks/useTranslate";
import clsx from "clsx";

//region [[ Styles ]]

const LocationMapSelectorView = styled("div")({
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-evenly",
  alignItems: "center",
  marginBottom: "15px",
  width: "100%",
});

const LocationMapChip = styled(Button)({
  "&.location-map-chip": {
    background: PatientColorMap.White,
    color: PatientColorMap.PrimaryDark,
    border: `1px solid ${PatientColorMap.Primary}`,
    borderRadius: "30px",
    transition: "all 0.5s ease-out",
    boxShadow: "none",
    padding: "6px 16px",
    "& span": {
      textTransform: "none",
      fontSize: "12px",
      lineHeight: "13px",
      fontWeight: 500,
      padding: "9x 13px",
    },
    "&.selected": {
      background: PatientColorMap.Primary,
      color: PatientColorMap.White,
    },
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface LocationMapSelectorProps {
  maps: LocationQuestionsMetaData[];
  current: number;
  onSelected: (index: number) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LocationMapSelector = ({ ...props }: LocationMapSelectorProps) => {
  const { translate } = useTranslate();
  return (
    <LocationMapSelectorView>
      {props.maps?.map((questionMetaData, index) => (
        <LocationMapChip
          key={index}
          className={clsx(
            "location-map-chip",
            index === props.current ? "selected" : "",
          )}
          onClick={() => props.onSelected(index)}
        >
          {translate(questionMetaData.subTitle || "")}
        </LocationMapChip>
      ))}
    </LocationMapSelectorView>
  );
};
